import { useEffect } from 'react';
import { navigate } from "@reach/router"

const IpcLydonPage = () => {
  useEffect(() => {
    navigate('/solutions/use-cases/equipment-maintenance/');
  }, []);
  return null;
};

export default IpcLydonPage;